import { useDispatch } from "react-redux";
import { getToday } from "@/services/Utils";
import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";

export function useEstatesExport(filters) {
	const dispatch = useDispatch();

	const handleExport = () => {
		const filename = `Bodegas ${getToday()}.xlsx`;

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: filters,
					show: true,
					url: "/app/maintainer/estate/export",
					name: filename,
					type: "excel",
					api: "go",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return { handleExport };
}
